module.exports = __webpack_public_path__ + "static/media/bgInsurance.18e3a460.jpg";